import { FormControl, Stack } from "@tm/components"
import { VoucherType } from "@tm/models"
import { ShowOnlyUserVouchersSwitch } from "./ShowOnlyUserVouchersSwitch"
import { ViewFilter } from "./ViewFilter"

type Props = {
    selectedVoucherType: VoucherType
    disabled: boolean
    onVoucherTypeChanged(event: React.ChangeEvent<HTMLInputElement>): void
}

export function VouchersFilter({ selectedVoucherType, disabled, onVoucherTypeChanged }: Props) {
    return (
        <Stack gap={1} width="160px">
            <FormControl disabled={disabled}>
                <Stack>
                    <ViewFilter selectedVoucherType={selectedVoucherType} onVoucherTypeChanged={onVoucherTypeChanged} />
                </Stack>
            </FormControl>
            <ShowOnlyUserVouchersSwitch showLabelStart labelPlacement="end" />
        </Stack>
    )
}
